import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { NbDialogService, NbCardModule, NbIconModule } from '@nebular/theme';
import { Store } from '@ngxs/store';
import { Observable, Subject, takeUntil } from 'rxjs';
import { RouterState } from 'src/app/features/auth/redux';
import { ACTIONS } from 'src/app/shared/constants/general-constants';
import { ENVIRONMENT } from 'src/environments/environment';
import { CampaignState, LoadCampaign, ReloadCampaign } from '../campaigns/redux';
import { InsightsState, LoadInsights, LoadInsightsInactive } from '../insights/redux';
import { WizardModalComponent } from './quick-start-wizard-modal/wizard-modal.component';
import { LoadContent } from '../../features/content/redux/content.actions';
import { LoadAllRobots, QaState } from '../qa-testing/redux';
import { NgIf } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';

@Component({
    selector: 'app-quick-start',
    templateUrl: './quick-start.component.html',
    styleUrls: ['./quick-start.component.css'],
    imports: [NgIf, NbCardModule, NbIconModule, SharedModule]
})
export class QuickStartComponent implements OnInit, OnDestroy {
  public campaign$: Observable<any[]> = inject(Store).select(CampaignState.campaign);
  public activeInsight$: Observable<any[]> = inject(Store).select(InsightsState.insightsActive);
  public inactiveInsight$: Observable<any[]> = inject(Store).select(InsightsState.insightsInactive);
  public username$: Observable<string> = inject(Store).select(RouterState.username);
  private unsubscribe: Subject<void> = new Subject();

  public username;
  public tableData;
  public insights = [];
  public showActions = [];
  public favorites;
  public isProduction: boolean = ENVIRONMENT.isProduction;

  constructor(private store: Store, private dialogService: NbDialogService) {
    this.store.dispatch(LoadInsights);
    this.store.dispatch(LoadInsightsInactive);
    this.store.dispatch(LoadCampaign);
    this.store.dispatch(LoadContent);
    if (this.store.selectSnapshot(QaState.robots).length < 1) {
      this.store.dispatch(new LoadAllRobots());
    }
  }

  public ngOnInit() {
    this.favorites = JSON.parse(localStorage.getItem('campaign_favorites')) || [];
    this.username$.pipe(takeUntil(this.unsubscribe)).subscribe((data) => (this.username = data));
    this.activeInsight$.pipe(takeUntil(this.unsubscribe)).subscribe((data) => {
      if (data) {
        this.insights = this.insights.concat(data);
      }
    });
    this.inactiveInsight$.pipe(takeUntil(this.unsubscribe)).subscribe((data) => {
      if (data) {
        this.insights = this.insights.concat(data);
      }
    });
    this.campaign$.pipe(takeUntil(this.unsubscribe)).subscribe((data) => {
      if (data) {
        this.tableData = data
          .filter((item) => item.created_by === this.username || this.favorites.includes(item.id))
          .map((item) => ({
            ...item,
            insight: this.insights.find(({ id }) => id === item.trigger_id)
          }));
      }
    });
  }

  public ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  public openModal(type: string) {
    this.dialogService.open(WizardModalComponent, {
      closeOnEsc: false,
      closeOnBackdropClick: false,
      context: {
        type
      }
    });
  }

  public clickedButton($event) {
    if ($event.action === ACTIONS.REFRESH) {
      this.tableData = undefined;
      this.store.dispatch(ReloadCampaign);
    }
  }
}
